var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMissingInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.152,
    height: 94.598,
    viewBox: "0 0 95.152 94.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2769",
    "data-name": "Group 2769",
    transform: "translate(-2557.827 -7339.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2769-2",
    "data-name": "Group 2769",
    transform: "translate(-561.867 -561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M3153.558,7958.65V7901h57.925v68.831",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M3161.457,7930.024a43.377,43.377,0,0,0,9.182,1.378c4.017,0,8.034-2.569,8.034-5.738s-5.624-5.165-8.034-5.739-8.034-2.569-8.034-5.738,4.017-5.739,8.034-5.739a63.671,63.671,0,0,1,9.181.917",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_809",
    "data-name": "Line 809",
    x2: 0.113,
    y2: 31.332,
    transform: "translate(3170.639 7904.774)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_810",
    "data-name": "Line 810",
    x2: 21.289,
    transform: "translate(3184.051 7907.057)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_811",
    "data-name": "Line 811",
    x2: 21.289,
    transform: "translate(3184.051 7915.482)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_812",
    "data-name": "Line 812",
    x2: 21.289,
    transform: "translate(3184.051 7923.907)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_813",
    "data-name": "Line 813",
    x2: 21.289,
    transform: "translate(3184.051 7932.332)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_814",
    "data-name": "Line 814",
    x2: 44.869,
    transform: "translate(3160.47 7943.182)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_815",
    "data-name": "Line 815",
    x2: 44.869,
    transform: "translate(3160.47 7951.607)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 14.341,
    height: 19.885,
    transform: "translate(3159.401 7961.65)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M3173.741,7964.5s4.4.133,7.457.133,8.03.994,11.013,2.983,0,7.954-4.971,5.965",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M3182.269,7971.593s8.948,3.977,12.925,3.977,8.745-3.052,11.352-4.474c4.556-2.486,6.91-1.39,7.538.5,1,2.983-2.982,5.965-4.971,6.96s-7.954,3.977-13.919,3.977-11.931-3.977-16.9-3.977-6.96,0-6.96,0",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M3187.508,7995l-33.917-53.812-33.9,53.792Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M3152.415,7979.693l-1.155-16.312v-6.822h4.682v6.822l-1.092,16.312Zm-.987,7.641v-4.3h4.346v4.3Z",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingInfo);
export default __webpack_public_path__ + "static/media/missing-info.2b5b928a088d2607acc7dfbe4e00ff43.svg";
export { ForwardRef as ReactComponent };